import camelCaseKeys from 'camelcase-keys'

export class WebappUserCredential {
  constructor (params = {}) {
    const { id, email, webappUserId, issuedSince, lastCredentialsMessageSentAt, createdAt, hasPassword } = camelCaseKeys(params)
    this.id = id || null
    this.email = email || null
    this.webappUserId = webappUserId || null
    this.issuedSince = issuedSince || null
    this.lastCredentialsMessageSentAt = lastCredentialsMessageSentAt || null
    this.createdAt = createdAt || null
    this.hasPassword = hasPassword || null
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      email: item.email,
    }
  }
}
